import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { catchError } from 'rxjs/operators';

import { UsersResource } from '../../../services/resources/users.resource';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'sl-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
    formGroup: UntypedFormGroup;
    isSaving = false;

    private matchErrorMsg: string;

    private readonly dialogRef = inject(MatDialogRef);
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly usersResource = inject(UsersResource);
    private readonly translationService = inject(TranslationService);

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group(
            {
                password: new FormControl(undefined, Validators.required),
                confirmPassword: new FormControl(undefined, Validators.required)
            },
            { validators: this.matchPassword }
        );
        this.translationService.getText('ChangePassword.PasswordsMustMatch').subscribe(r => (this.matchErrorMsg = r));
    }

    changePassword(): void {
        this.isSaving = true;
        this.usersResource
            .updatePassword(this.formGroup.value.password)
            .pipe(
                catchError(() => {
                    this.isSaving = false;
                    return '';
                })
            )
            .subscribe(() => {
                this.isSaving = false;

                this.formGroup.reset();
                this.dialogRef.close();
            });
    }

    private matchPassword = (formGroup: UntypedFormGroup): any => {
        if (formGroup.controls['password'].value !== formGroup.controls['confirmPassword'].value) {
            formGroup.controls['confirmPassword'].setErrors({ invalidConfirmPassword: this.matchErrorMsg });
        } else {
            return undefined;
        }
    };
}
